import { MutableRefObject, useEffect } from 'react';

export const useScrollToElementEffect = (
    ref: string | HTMLElement | MutableRefObject<HTMLElement>,
    shouldScroll: boolean
) => {
    useEffect(() => {
        if (!ref || !shouldScroll) {
            return;
        }
        setTimeout(() => {
            let el: HTMLElement;
            if (typeof ref === 'string') {
                el = document.querySelector(ref);
            } else if ('current' in ref) {
                el = ref.current;
            } else {
                el = ref;
            }
            el?.scrollIntoView();
        }, 0);
    }, [ref, shouldScroll]);
};
